<template>
  <div
    v-if="visible && date"
  >{{ `Time Left: ${("0" + date.hours).slice(-2)}:${("0" + date.minutes).slice(-2)}:${("0" + date.seconds).slice(-2)}` }}</div>
</template>

<script>
import countdown from "countdown";

export default {
  name: "Timer",
  data() {
    return {
      date: null,
      visible: true,
      events: {
        countdownInterval: null,
        clearIntervalTimeout: null
      }
    };
  },
  methods: {
    postLoad() {
      // this.events.clearIntervalTimeout = setTimeout(() => {
      //   console.log("clearCountdownFunction called");
      //   this.visible = false;
      //   window.clearInterval(this.events.countdownInterval);
      // }, this.endTimer * 1000 );

      this.events.countdownInterval = setInterval(() => {
        this.date = countdown(
          null,
          new Date(this.endTimer * 1000),
          countdown.HOURS | countdown.MINUTES | countdown.SECONDS
        );
        if(this.date.value < 0){
          clearInterval(this.events.countdownInterval);
        }
      }, 1000);

      
    }
  },
  props: ["endTimer"],
  created: function() {
    //   console.log(Date(this.endTimer * 1000));

    this.postLoad();
  },

  beforeDestroy() {
    window.clearInterval(this.events.countdownInterval);
    window.clearTimeout(this.events.clearIntervalTimeout);
  }
};
</script>

<style scoped>
</style>